import axios from 'axios';
import { pinia } from '@/main';
import { isTokenExpired, useAuthStore } from '@/stores/auth';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

// Request interceptor to add the access token to headers and refresh if about to expire
// Request interceptor
axiosInstance.interceptors.request.use(
  async (config) => {
    const authStore = useAuthStore(pinia);
    if (authStore.accessToken) {
      if (isTokenExpired(authStore.accessToken, 300)) {
        try {
          const newAccessToken = await authStore.refreshAccessToken();
          config.headers.Authorization = `Bearer ${newAccessToken}`;
        } catch (error) {
          authStore.logout();
          return Promise.reject(error);
        }
      } else {
        config.headers.Authorization = `Bearer ${authStore.accessToken}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Response interceptor to handle token refresh on 401
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const authStore = useAuthStore(pinia);
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await authStore.refreshAccessToken();
        axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
        originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        authStore.logout();
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);


export default axiosInstance;
